import { Injectable } from '@angular/core';
import { Result } from '../../../../../shared/model/response.model';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { DataService } from '../../../../../shared/services/data.service';
import { TablePaginationModel, VendorPartLibraryPaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';

@Injectable({
  providedIn: 'root'
})
export class VendorPartsLibraryService {


  constructor(public service:DataService) { }


  getAllVendorPartLibrary(data: VendorPartLibraryPaginationModel): Observable<Result> {
      let url = 'app/parts_Inventory/getAllVendorPartList';
      return this.service.getWithParams(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }
    addVendorPart(data: any): Observable<Result> {
      let url = 'app/parts_Inventory/addVendorPart';
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }
    
  updateExpirationDate(data: any): Observable<Result> {
    let url = 'app/parts_Inventory/updateExpirationDate';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getVendorPartById(id:string): Observable<Result> {
    let url = `app/parts_Inventory/getVendorPartById?Id=${id}`;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
     return response;
      })
    );
  }
  getUpdateVendor(data: any): Observable<Result> {
    let url = "app/parts_Inventory/updateVendorPart";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response
      })
    )
  }
  deleteVendorParts(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/deleteVendorPart';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  } 
  getAllRequestVPL(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/getAllRequestVendorPartList';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  UpdateRequestVPL(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/updateRequestVendorPartList';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
